import { ClearMealDishes } from '../index'

export default function ClearMealDishesFunc(mealId: any) {
  return ClearMealDishes(mealId)
}
